export enum SectionType {
    home_page = 'home_page',
    library = 'library',
    gallery = 'gallery',
    activity = 'activity',
    calendar = 'calendar',
    notification_center = 'notification_center',
    store_list = 'store_list',
    quick_link = 'quick_link',
}

export enum SectionFilter {
    draft = 'draft',
    toBeReleased = 'toBeReleased',
    released = 'released',
    rejected = 'rejected',
    new = 'new',
    inProgress = 'inProgress',
    read = 'read',
    inApproval = 'inApproval',
    closed = 'closed',
    cancelled = 'cancelled',
    redo = 'redo',
    overdue = 'overdue',
    recalled = 'recalled',
    completed = 'completed',
}

export enum SectionQuery {
    sectionType = 'sectionType',
    sectionFilter = 'sectionFilter',
    both = 'both',
}
